(function () {
  'use strict';

  var STORAGE_KEY = 'nr-radio-state';

  function readState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function getTrackUrl(state) {
    if (state.trackUrl) return state.trackUrl;
    var tracks = window.__NR_RADIO__ && window.__NR_RADIO__.tracks;
    if (!tracks || !tracks.length) return '';
    var index = state.trackIndex || 0;
    return tracks[index] && tracks[index].url ? tracks[index].url : '';
  }

  var state = readState();
  if (!state || !state.isPlaying) return;

  var audio = document.getElementById('nr-radio-audio');
  if (!audio) return;

  var url = getTrackUrl(state);
  if (!url) return;

  audio.preload = 'auto';
  audio.muted = !!state.muted;
  audio.src = url;
  audio.dataset.nrRadioBootstrapped = 'true';

  function resume() {
    try {
      if (state.currentTime > 0) {
        audio.currentTime = state.currentTime;
      }
    } catch (e) {
      /* ignore seek before ready */
    }

    audio.play().catch(function () {
      /* autoplay policy — user can press power */
    });
  }

  if (audio.readyState >= 1) {
    resume();
  } else {
    audio.addEventListener('loadedmetadata', resume, { once: true });
  }
})();
